import React from 'react'
/* import { makeStyles } from '@material-ui/core/styles' */
import { Container, Grid, Paper } from '@material-ui/core'
/* import clsx from 'clsx' */
import QuestionForm from '../Components/QuestionForm'
import LastQuestions from '../Components/LastQuestions'

/* const useStyle = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 300,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: '1.5rem',
  },
  pos: {
    marginBottom: 12,
  },
})) */

export default function Questions(props) {
  /*   const classes = useStyle()
   */ return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper elevation={4} style={{ paddingBottom: 40 }}>
          <QuestionForm></QuestionForm>
        </Paper>
      </Grid>
    </Grid>
  )
}
